import { useEffect, useRef } from 'react';

/**
 * Auto-refresh hook that calls a callback on an interval.
 * Uses a ref to always call the latest callback without re-creating the interval.
 */
export function useAutoRefresh(callback: () => void, intervalMs = 30000) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const id = setInterval(() => callbackRef.current(), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
}
